import { Context } from '@wix/wix-chatbot-common/browser';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';

const { clientTopology } = renderModel.get();

export const chatbotStartChat = async (
  params: Record<string, string> = {},
  context: Context,
  forceStartChat: boolean = false,
): Promise<IInitialChatData> => {
  try {
    fedopsLogger.interactionStarted('fetching-chatbot-start-chat');
    const { data } = await httpClient.getInstance().post<IInitialChatData>(clientTopology.startChatUrl, {
      context,
      forceStartChat,
      params,
    });
    fedopsLogger.interactionEnded('fetching-chatbot-start-chat');
    return data;
  } catch (error) {
    logger.error({
      message: 'failed to complete start-chat request',
      error,
    });
    console.error(error);
    throw error;
  }
};
